import React, { useEffect } from 'react';
import { Row, Col } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import storage from "utils/Storage";

// Tabs
import Account from "./Account";
import Security from "./Security";
import Preferences from "./Preferences";
import ApiKeys from "./Api";
import Verification from "./Verification";
import Offers from "./Offers";

// Icons
import { 
  UserCircle2, 
  ShieldCheck, 
  Settings2, 
  Code2, 
  BadgeCheck, 
  Gift 
} from "lucide-react";

const SettingsContainer = styled.div`
  display: flex;
  color: #fff;
  max-width: 1100px;
  margin: 0 auto;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.div`
  width: 250px;
  flex-shrink: 0;
  padding: 0;
  position: sticky;
  top: 80px;
  align-self: flex-start;

  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    overflow-x: auto;
    border-right: none;
    border-bottom: 1px solid #292d2e;
    padding: 10px;
    
    /* Hide scrollbar for mobile */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

const SidebarTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  padding: 0 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavItem = styled(Link)`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: ${props => props.active ? "#fff" : "#9ca3af"};
  background-color: ${props => props.active ? "#292d2e" : "transparent"};
  text-decoration: none;
  font-weight: ${props => props.active ? "bold" : "normal"};
  transition: all 0.2s ease-in-out;
  border-left: ${props => props.active ? "3px solid #1fc16b" : "3px solid transparent"};

  &:hover {
    color: #fff;
    background-color: #292d2e;
    text-decoration: none;
  }

  svg {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    color: ${props => props.active ? "#1fc16b" : "#9ca3af"};
  }

  @media (max-width: 768px) {
    padding: 10px 16px;
    border-left: none;
    border-bottom: ${props => props.active ? "3px solid #1fc16b" : "3px solid transparent"};
    border-radius: 8px;
    white-space: nowrap;
    
    &:hover {
      background-color: #292d2e;
    }
  }
`;

const ContentArea = styled.div`
  flex-grow: 1;
  width: 100%;
  padding: 0;


  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0;
`;

const Setting = () => {
  const history = useHistory();
  const { tab } = useParams();
  
  const currentTab = tab || 'account';

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    if (storage.getKey('logged') !== 'true') {
      history.push('../');
    }
  }, [history]);

  const renderContent = () => {
    switch (currentTab) {
      case 'account': return <Account />;
      case 'security': return <Security />;
      case 'preferences': return <Preferences />;
      case 'api': return <ApiKeys />;
      case 'verification': return <Verification />;
      case 'offers': return <Offers />;
      default: return <Account />;
    }
  };

  return (
    <div style={{ padding: '40px 20px', minHeight: '80vh' }}>
      <SettingsContainer>
        <Sidebar>
          <SidebarTitle>Settings</SidebarTitle>
          <NavItem to="/settings/account" active={currentTab === 'account' ? 1 : 0}>
            <UserCircle2 /> Account
          </NavItem>
          <NavItem to="/settings/security" active={currentTab === 'security' ? 1 : 0}>
            <ShieldCheck /> Security
          </NavItem>
          {/* <NavItem to="/settings/preferences" active={currentTab === 'preferences' ? 1 : 0}>
            <Settings2 /> Preferences
          </NavItem> */}
          <NavItem to="/settings/api" active={currentTab === 'api' ? 1 : 0}>
            <Code2 /> API
          </NavItem>
          {/* <NavItem to="/settings/verification" active={currentTab === 'verification' ? 1 : 0}>
            <BadgeCheck /> Verification
          </NavItem>
          <NavItem to="/settings/offers" active={currentTab === 'offers' ? 1 : 0}>
            <Gift /> Offers
          </NavItem> */}
        </Sidebar>
        
        <ContentArea>
          <ContentWrapper>
            {renderContent()}
          </ContentWrapper>
        </ContentArea>
      </SettingsContainer>
    </div>
  );
};

export default Setting;
 
